import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { lazy, Suspense } from 'react'
import { Layout } from './components/Layout'

const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))
const DocsPage = lazy(() => import('./pages/DocsPage'))
const ReleaseNotesPage = lazy(() => import('./pages/ReleaseNotesPage'))


function App() {
  return (
    <ThemeProvider>
      <Layout>
        <Suspense
          fallback={
            <div className="flex h-screen flex-1 items-center justify-center bg-white dark:bg-slate-900">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-sky-500 dark:border-slate-700 dark:border-t-sky-400"></div>
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Navigate to="/docs/introduction" replace />} />
            <Route path="/docs/*" element={<DocsPage />} />
            <Route path="/troubleshoot/*" element={<DocsPage />} />
            <Route path="/sdk/*" element={<DocsPage />} />
            <Route path="/release-notes" element={<ReleaseNotesPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </ThemeProvider>
  )
}

export default App
